import { render, staticRenderFns } from "./Consignee.vue?vue&type=template&id=12c19580&scoped=true&"
import script from "./Consignee.vue?vue&type=script&lang=js&"
export * from "./Consignee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c19580",
  null
  
)

export default component.exports